import AvailabilityCalendar, {
  IUnavailableDates,
} from "models/AvailabilityCalendar";
import { HttpClient } from "./HttpClient";
import { getApiUrl } from "./UrlBuilder";
import { HALManager, UserManager } from "core";
import { HttpOperationError } from "shared/utils/exceptions";

export class AvailabilityCalendarService {
  private httpClient: HttpClient = new HttpClient();

  public async getAvailabilityCalendar() {
    const urlRequest = getApiUrl(
      HALManager.getAvailabilityCalendarUrl(UserManager.userId)
    );

    try {
      const response = await this.httpClient.get<AvailabilityCalendar>(
        urlRequest
      );
      return response.object;
    } catch (error) {
      throw new HttpOperationError(
        urlRequest,
        "Getting availability calendar failed"
      );
    }
  }

  public async createAvailabilityCalendarItem(
    body: Omit<IUnavailableDates, "id">
  ) {
    const urlRequest = getApiUrl(
      HALManager.postAvailabilityCalendarUrl(UserManager.userId)
    );

    try {
      const response = await this.httpClient.post<AvailabilityCalendar>(
        urlRequest,
        {
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      return response.object;
    } catch (error) {
      throw new HttpOperationError(
        urlRequest,
        "Creating availability calendar item failed"
      );
    }
  }

  public async deleteAvailabilityCalendarItem(itemId: string) {
    const urlRequest = getApiUrl(
      HALManager.deleteAvailabilityCalendarUrl(UserManager.userId, itemId)
    );
    try {
      const response = await this.httpClient.delete(urlRequest);
      return response.object;
    } catch (error) {
      throw new HttpOperationError(
        urlRequest,
        "Deleting availability calendar item failed"
      );
    }
  }
}

export default new AvailabilityCalendarService();
